import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { Option } from "react-bootstrap-typeahead/types/types";

//App
import { LookupTypeContext } from "../LookupTypeContainer";
import {
  LookupTypeContextData,
  LookupTypeProps,
  LookupTypeApiResponse,
  LookupTypeState,
} from "../../../../../types/lookupType";
import useForm from "../../../../hooks/useForm";
import lookupTypeApi from "../../../../../app/model/api/lookupTypeApi";
import { GetAllLookupTypes } from "../../../../../app/model/api/types/apiTypes";
import { FormikTypeaheadOption } from "../../../../../types";
import { queryKeys } from "../constants";
import { EMPTY_GUID } from "../../../../../utility/constants";
import { LookupDto } from "../../../../../app/model/api/types/dto";

const useLookupType = (props: LookupTypeProps) => {
  return useForm<LookupTypeContextData, LookupTypeProps>(
    LookupTypeContext,
    props
  );
};

const mapLookupTypeToOption = (type: LookupDto): FormikTypeaheadOption => ({
  label: type.name as string,
  value: type.id as string,
});

export const useLookupTypeGridQuery = (state: LookupTypeState) =>
  useQuery({
    queryKey: [queryKeys.getLookupTypeGrid],
    queryFn: () =>
      lookupTypeApi.searchLookupType({
        ...state.searchPayload,
        pageSize: state.pageSize,
        pageNumber: state.currentPage ?? 1,
        isActive: state.activeToggle,
        sortBy: state.sortBy ?? [],
      }),
  });

export const useLookupTypesQuery = (
  payload: GetAllLookupTypes,
  isDropDown: boolean = false,
  isGrouped: boolean = false
) => {
  return useQuery({
    queryKey: [queryKeys.getLookupTypes],
    queryFn: () => lookupTypeApi.getAll(payload),
    select: (data) => {
      if (isDropDown) {
        const filteredData = isGrouped
          ? data?.result?.filter((lookupType) => lookupType.isGrouped === true)
          : data?.result;

        return filteredData?.map(
          mapLookupTypeToOption
        ) as FormikTypeaheadOption[];
      }

      return data;
    },
  });
};

export const useLookupTypeQuery = (lookupTypeId: string | null) =>
  useQuery({
    queryKey: [queryKeys.getLookupType, lookupTypeId],
    queryFn: () => lookupTypeApi.get(lookupTypeId ?? EMPTY_GUID),
    enabled: lookupTypeId !== null,
  });

export const useLookupTypesData = (
  lookupTypeGridQuery: UseQueryResult<LookupTypeApiResponse | Option[], Error>
) => (lookupTypeGridQuery?.data as LookupTypeApiResponse)?.result;

export default useLookupType;
